import { Theme } from '@/theme';
import styled, { css } from 'styled-components';
import Button from '@CS/components/Button/Button.styles';
import { BUTTON_WIDTH } from '@CS/components/Popups/Leaderboard/weeks';

type WeekButtonAttributes = {
  selected?: boolean;
};

export default styled(Button)<WeekButtonAttributes>(
  ({ selected }) => css`
    &&& {
      min-width: ${BUTTON_WIDTH}px;
      background-color: #f5f4f4;
      width: ${BUTTON_WIDTH}px;

      border-radius: 50px;
      padding: 12px 15px;
      line-height: 10px;
      color: #9c9c9c;
      font-size: 10px;

      padding: 12px;
      height: 30px;

      ${selected &&
      css`
        color: black;
        background-color: ${Theme.color.orange};
      `}

      &:active {
        background-color: ${Theme.color.orange};
        transform: revert;
      }
    }
  `
);
